import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function parseExpiration(startTime, duration) {
    if (!startTime) {
        return '00:00';
    }

    const diff = (60 * duration) - (((Date.now() - startTime) / 1000) | 0);

    let minutes = (diff / 60) | 0;
    let seconds = (diff % 60) | 0;

    if (minutes <= 0) {
        minutes = 0;
    } else {
        minutes = minutes < 10 ? '0' + minutes : minutes;
    }

    if (minutes === 0 && seconds <= 0) {
        seconds = 0;
    } else {
        seconds = seconds < 10 ? '0' + seconds : seconds;
    }

    return `${minutes}:${seconds}`;
}

function getExpirationState(startTime, duration) {
    if (startTime == null) {
        return 'inactive';
    }

    const diffInMinutes = Math.floor(
        (new Date().getTime() - startTime) / 1000,
    ) / 60;

    return diffInMinutes >= duration ? 'expired' : 'active';
}

export function useCartExpiration() {
    const durationInMinutes = 15;

    const startTime = useSelector(state => state.cart.start_time);

    const [timer, setTimer] = useState(parseExpiration(
        startTime,
        durationInMinutes,
    ));

    const state = getExpirationState(startTime, durationInMinutes);

    useEffect(() => {
        if (state !== 'active') {
            return;
        }

        function poll() {
            setTimer(parseExpiration(startTime, durationInMinutes));
        }

        const interval = setInterval(poll, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [state, startTime, setTimer]);

    return {
        state: state,
        timer: timer,
    };
}
